<template>
  <div>
    <vModal
      v-for="[key, modal] in modals"
      :key="modal.modalId"
      :name="modal.modalId"
      size="sms"
      :title="modal.title"
      @close="onClose(key)"
    >
      <component
        :is="modal.component ?? Confirm"
        @close="modal$.hide(modal.modalId)"
        @confirm="onConfirm(key)"
      >
        <template v-if="modal.description" #description>
          <div v-html="modal.description" />
        </template>
        <template v-if="modal.buttonClose" #buttonClose>
          {{ modal.buttonClose }}
        </template>
      </component>
    </vModal>
  </div>
</template>
<script>
import vModal from '../../../components/vModal.vue';
import { nextTick, shallowRef, triggerRef, watch, inject } from 'vue';
import Confirm from './Confirm.vue';
import { useId } from '../../../hooks/useId';
import { useConfirmModalStore } from '../../../store/useConfirmModalStore';

export default {
  name: 'ConfirmModal',
  components: {
    vModal,
  },
  setup() {
    const modal$ = inject('$modal');

    const { modals: storeModals, close: closeModal } = useConfirmModalStore();

    const makeModal = ({ title, description, buttonClose }) => {
      return {
        modalId: useId(),
        title,
        description,
        buttonClose,
      };
    };

    const modals = shallowRef(new Map());
    watch(storeModals, (storeModals) => {
      // sync
      storeModals.forEach((modal) => {
        if (!modals.value.has(modal)) {
          const meta = makeModal(modal);
          modals.value.set(modal, meta);

          nextTick().then(() => modal$.show(meta.modalId));
        }
      });
      [...modals.value.keys()].forEach((modal) => {
        if (!storeModals.has(modal)) {
          const meta = modals.value.get(modal);
          modal$.hide(meta.modalId);

          nextTick().then(() => modals.value.delete(modal));
        }
      });
      triggerRef(modals);
    }, { immediate: true, deep: true });

    const onClose = (key) => {
      nextTick().then(() => closeModal(key));
    };

    return {
      modals,
      Confirm,
      storeModals,
      onClose,
      modal$,
    };
  },
};
</script>